module.exports = __webpack_public_path__ + "static/quick-roll-gif-90eb0491cab5d2a884e64043dedb35d6.gif";